module.exports = "/dist/roboto-latin-400italic.svg?13fb9544bc459a2351bbcf844f5763d8";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-400italic.svg
// module id = 89
// module chunks = 0